import { render, staticRenderFns } from "./LoyaltyDiscounts.vue?vue&type=template&id=713996a9&scoped=true&"
import script from "./LoyaltyDiscounts.vue?vue&type=script&lang=js&"
export * from "./LoyaltyDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyDiscounts.vue?vue&type=style&index=0&id=713996a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713996a9",
  null
  
)

export default component.exports